import { render, staticRenderFns } from "./bv-product-image.vue?vue&type=template&id=ffcc9b3e&"
import script from "./bv-product-image.vue?vue&type=script&lang=ts&"
export * from "./bv-product-image.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports